module.exports = __webpack_public_path__ + "static/media/cq_aggiorna b.d953f7ea.svg";